import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { mvpRoutes } from './mvp';
import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

const CenteredSignInPage = lazy(() => import('src/pages/auth/sign-in'));
const Page404 = lazy(() => import('src/pages/error/404'));
const RunPage = lazy(() => import('src/pages/run'));
const SeetCapturePage = lazy(() => import('src/pages/seet/[seetId]'));
const FeaturebaseSSOPage = lazy(() => import('src/pages/sso/featurebase'));

export const routesSection: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <AuthCenteredLayout>
          <CenteredSignInPage />
        </AuthCenteredLayout>
      </Suspense>
    ),
  },

  // Public run page (no authentication required)
  {
    path: '/run/:runId',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <RunPage />
      </Suspense>
    ),
  },

  // Seet capture page
  {
    path: '/seet/:seetId',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <SeetCapturePage />
      </Suspense>
    ),
  },

  // Featurebase SSO
  {
    path: '/sso/featurebase',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <FeaturebaseSSOPage />
      </Suspense>
    ),
  },

  // Auth
  ...authRoutes,

  // Dashboard
  ...dashboardRoutes,

  // MVP
  ...mvpRoutes,

  // Main
  ...mainRoutes,

  // No match
  { path: '*', element: <Page404 /> },
];
